export const InfoIcon : string = 'https://cdn.dresden.vision/static-images/afterpay-info.png';

export const zipPayLogo : string = 'https://cdn.dresden.vision/static-images/zip-pay.png';

export const afterPayLogo : string = 'https://cdn.dresden.vision/static-images/afterpay-logo.webp';